/** Matches the uninstall survey in OverlayQALaunch/public/uninstall/index.html. */
export const CHURN_REASONS = [
    'trial_expired', 'too_expensive', 'missing_feature', 'broken',
    'too_complicated', 'found_alternative', 'dont_need', 'other',
];
/**
 * The uninstall survey's reasons: CHURN_REASONS behind a first radio for the people
 * who are not leaving. Measured 2026-10-24 on production: 13 of the 24 uninstall rows
 * tied to an account were filed within an hour of sign-up, 4 of those people created
 * issues after the uninstall, and 3 picked the first radio ("Trial expired") within
 * 20 minutes of signing up. Account deletion keeps CHURN_REASONS as is: nobody
 * reinstalls a deleted account.
 *
 * Two more since 2026-11-01 (Emily, "do 9"), uninstall-only for the same reason:
 * `account_required` ("Didn't want to create an account"), because the extension
 * now opens on the sign-in card and a person who leaves there had no honest radio
 * (the 2026-08-17 read saw one pick "Trial expired"); and `privacy_security`
 * ("Security, privacy or compliance concerns"), because OverlayQA asks for the
 * debugger permission and no reason could name that worry. The page lists the
 * radios in this order (OverlayQALaunch public/uninstall/index.html), 'other' last.
 */
export const UNINSTALL_REASONS = [
    'reinstalling', 'account_required',
    'trial_expired', 'too_expensive', 'missing_feature', 'broken',
    'privacy_security',
    'too_complicated', 'found_alternative', 'dont_need', 'other',
];
export const CHURN_REASON_LABELS = {
    trial_expired: 'Trial expired',
    too_expensive: 'Too expensive',
    missing_feature: 'Missing a feature I need',
    broken: 'Something was broken',
    too_complicated: 'Too complicated to use',
    found_alternative: 'Found an alternative',
    dont_need: "Don't need it anymore",
    other: 'Other',
};
export function churnCommentPlaceholder(reason) {
    if (reason === 'broken')
        return 'What stopped working? One sentence helps us fix it. (optional)';
    if (reason === 'missing_feature')
        return 'Which feature did you need? (optional)';
    if (reason === 'other')
        return 'What happened? (optional)';
    return "Anything else you'd like to share? (optional)";
}
//# sourceMappingURL=churnFeedback.js.map